<template>
    <div class="analysis-method__wrapper mb-5" v-if="completedExaminations">
        <h3 class="title-content">{{ $t('ANALYSIS_METHOD') }}</h3>
        <div class="analysis-method__info">
            <p>
                {{ $t('ACTUAL_ANALYSIS_METHOD') }}:
                <span class="bold">{{ analysisMethod }}</span>
            </p>

            <p v-if="completedExaminations <= stepsLength">
                {{ $t('REQUIREMENTS_FOR_COMPARABLE_METHOD', { number: stepsLength + 1 - completedExaminations })
                }}<br />
                {{ $t('REQUIREMENTS_FOR_COMPARABLE_METHOD_2') }}
            </p>
        </div>

        <div class="analysis-method__status">
            <div class="status--regular">
                <h5 class="status__title">{{ $t('BASIC_METHOD') }}</h5>
                <div class="status__steps">
                    <div
                        class="step"
                        v-for="step in stepsLength"
                        :class="{ 'step--active': step <= completedExaminations }"
                    ></div>
                </div>
            </div>
            <div class="status--comparative">
                <h5 class="status__title">{{ $t('BASIC_AND_COMPARABLE_METHOD') }}</h5>
                <div class="status__steps">
                    <div class="step" :class="{ 'step--active': completedExaminations > stepsLength }"></div>
                </div>
            </div>
            <div class="status__info box-shadow" v-if="completedExaminations <= stepsLength">
                {{ $t('REQUIREMENTS_FOR_COMPARABLE_METHOD', { number: stepsLength + 1 - completedExaminations }) }}
            </div>
            <div class="status__info" v-else>
                {{ $t('COMPARABLE_METHOD_IS_ACTIVE') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['completedExaminations'],
    data() {
        return {
            stepsLength: 5,
        };
    },
    computed: {
        analysisMethod() {
            return this.completedExaminations <= this.stepsLength
                ? this.$t('BASIC_METHOD')
                : this.$t('BASIC_AND_COMPARABLE_METHOD');
        },
    },
};
</script>

<style lang="scss" scoped>
.analysis-method {
    &__wrapper {
        position: relative;
    }

    &__info {
        color: #67635f;
        margin-bottom: 30px;
        padding-right: 220px;
    }

    &__status {
        color: #67635f;
        display: flex;
        flex-wrap: nowrap;
    }
}

.status {
    &--regular {
        width: 30%;
    }

    &--comparative {
        width: 70%;
    }

    &__title {
        font-size: 16px;
        color: #333;
        font-weight: 700;
    }

    &__steps {
        display: flex;
        justify-content: space-between;
        padding-right: 5px;
    }

    &__info {
        border: 1px solid #ede8e4;
        font-size: 14px;
        line-height: 16px;
        padding: 15px;
        position: absolute;
        right: 10px;
        bottom: 35px;
        width: 180px;

        &:before,
        &:after {
            left: 30px;
            top: 100%;
            border: solid transparent;
            content: ' ';
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
        }

        &:before {
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 12px solid transparent;
            border-top: 12px solid #ede8e4;
        }

        &:after {
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 10px solid #fff;
        }
    }
}

.step {
    background: transparent;
    border: 1px solid #d9d3cf;
    height: 20px;
    flex-grow: 1;
    margin-right: 5px;

    &--active {
        background-color: #cf004a;
        border-color: #cf004a;
    }
}

.bold {
    color: #333;
    font-weight: 700;
}

@media (max-width: 768px) {
    .analysis-method {
        &__info {
            color: #67635f;
            margin-bottom: 30px;
            padding-right: 15px;
        }

        &__status {
            flex-wrap: wrap;
            flex-direction: column;
        }
    }

    .status {
        &__info {
            position: relative;
            order: 1;
            margin-bottom: 0;
            margin-left: auto;
            margin-top: 15px;

            &:before,
            &:after {
                display: none;
            }
        }

        &--regular,
        &--comparative {
            order: 2;
            width: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// analysis-method.vue?3ceb647e